import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { feedDate, feedPath } from './feedPresentation';

export default function FeedCard({ post, actionButton }) {
  return (
    <Box sx={{ position: 'relative', minWidth: 0 }}>
      <Box
        component={Link}
        to={feedPath(post)}
        aria-label={post.title}
        sx={{
          display: 'block',
          position: 'relative',
          aspectRatio: '1',
          overflow: 'hidden',
          borderRadius: '20px',
          bgcolor: '#333',
          color: '#fff',
          textDecoration: 'none',
          '&:focus-visible': { outline: '3px solid #F16438', outlineOffset: 3 },
        }}
      >
        {post.imageUrl && (
          <Box
            component="img"
            src={post.imageUrl}
            alt=""
            loading="lazy"
            sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        )}
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(transparent 25%, rgba(0,0,0,.85))',
          }}
        />
        <Box sx={{ position: 'absolute', bottom: 16, left: 16, right: 16 }}>
          <Typography noWrap sx={{ fontWeight: 700, fontSize: 18, color: '#fff' }}>
            {post.title}
          </Typography>
          {post.excerpt && (
            <Typography
              sx={{
                fontSize: 14,
                lineHeight: 1.5,
                color: 'rgba(255,255,255,.84)',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                my: 0.5,
              }}
            >
              {post.excerpt}
            </Typography>
          )}
          <Typography sx={{ fontSize: 12, color: 'rgba(255,255,255,.7)', mt: 1 }}>
            {feedDate(post.createdAt || post.date)}
          </Typography>
        </Box>
      </Box>
      {actionButton && <Box sx={{ position: 'absolute', top: 12, right: 12 }}>{actionButton}</Box>}
    </Box>
  );
}
